require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-idb-safeguard-review-disability.json") })
        }
      }, "path---en-us-update-idb-safeguard-review-disability");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-idb-safeguard-review-disability!./.cache/json/en-us-update-idb-safeguard-review-disability.json
// module id = 751
// module chunks = 231608221292675